/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaxAccountantOnboardingRequest = {
    usageType: TaxAccountantOnboardingRequest.usageType;
    monthlyDocuments: TaxAccountantOnboardingRequest.monthlyDocuments;
};

export namespace TaxAccountantOnboardingRequest {
    export enum usageType {
        COMPANY = "COMPANY",
        ACCOUNTING_FIRM = "ACCOUNTING_FIRM",
        FREELANCE_ACCOUNTANT = "FREELANCE_ACCOUNTANT",
        OTHER = "OTHER",
    }

    export enum monthlyDocuments {
        UP_TO_100 = "UP_TO_100",
        FROM_100_TO_500 = "FROM_100_TO_500",
        FROM_500_TO_2000 = "FROM_500_TO_2000",
        OVER_2000 = "OVER_2000",
        UNKNOWN = "UNKNOWN",
    }
}
